import request from './request';

interface GenerateAiResponse {
  content: string;
}

/**
 * 生成 AI 回复 (WhatsApp 助理)
 * @param prompt 用户输入
 */
export const generateAiContentStream = async (prompt: string): Promise<string> => {
  try {
    const response = await request.post('/api/ai/generate', { prompt });
    const data = (response && response.data) || response;
    return (data && data.content) || '';
  } catch (error) {
    console.error('Failed to generate AI content:', error);
    throw error;
  }
};

/**
 * 生成运营助理回复
 * @param prompt 用户输入
 */
export const generateOpsContent = async (prompt: string): Promise<string> => {
  try {
    const response = await request.post('/api/ai/generate-alt', { prompt });
    const data = (response && response.data) || response;
    return (data && data.content) || '';
  } catch (error) {
    console.error('Failed to generate Ops AI content:', error);
    throw error;
  }
};

/**
 * 获取订单分析智能体提示词和配置
 */
export const getOrderAnalysisConfig = async (): Promise<{ instructions: string; filterCsNumbers: boolean }> => {
  try {
    const response = await request.get('/api/ai/order-analysis/instructions');
    const data = (response && response.data) || response;
    return {
      instructions: (data && data.instructions) || '',
      filterCsNumbers: data && data.filter_cs_numbers !== undefined ? data.filter_cs_numbers : true
    };
  } catch (error) {
    console.error('Failed to get order analysis config:', error);
    throw error;
  }
};

/**
 * 更新订单分析智能体提示词和配置
 * @param instructions 新的提示词
 * @param filterCsNumbers 是否过滤客服号码
 */
export const updateOrderAnalysisConfig = async (instructions: string, filterCsNumbers: boolean): Promise<{ instructions: string; filterCsNumbers: boolean }> => {
  try {
    const response = await request.put('/api/ai/order-analysis/instructions', { 
      instructions,
      filter_cs_numbers: filterCsNumbers
    });
    const data = (response && response.data) || response;
    return {
      instructions: (data && data.instructions) || '',
      filterCsNumbers: data && data.filter_cs_numbers !== undefined ? data.filter_cs_numbers : true
    };
  } catch (error) {
    console.error('Failed to update order analysis config:', error);
    throw error;
  }
};


